import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "./firebase";

// Read-only list of the notes this user can see: owned + shared via memberEmails (same two queries
// as Notes.js, merged client-side). Used by Dashboard.js and Pods.js; Notes.js keeps its own.
export default function useVisibleNotes(uid, email) {
  const [notes, setNotes] = useState([]);
  useEffect(() => {
    if (!uid || !email) return;
    const owned = {}, shared = {};
    const merge = () => setNotes(Object.values({ ...shared, ...owned }));
    const fill = (target) => (snap) => {
      Object.keys(target).forEach((k) => delete target[k]);
      snap.docs.forEach((d) => { target[d.id] = { id: d.id, ...d.data() }; });
      merge();
    };
    const u1 = onSnapshot(query(collection(db, "notes"), where("ownerUid", "==", uid)), fill(owned));
    const u2 = onSnapshot(query(collection(db, "notes"), where("memberEmails", "array-contains", email)), fill(shared));
    return () => { u1(); u2(); };
  }, [uid, email]);
  return notes;
}
